import { render, staticRenderFns } from "./ViewCustomers.vue?vue&type=template&id=2ff4398a&"
import script from "./ViewCustomers.vue?vue&type=script&lang=js&"
export * from "./ViewCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports